import { Item } from '../../../types/interfaces';
import { useCartItemQuantity } from '../hooks/useCartItemQuantity';

interface CartItemLogicProps {
  item: Item;
  CartItemUI: (props: {
    item: Item;
    quantity: number;
    verificationQuantity: number;
    passportQuantity: number;
    onQuantityChange: (value: number) => void;
    onVerificationQuantityChange: (value: number) => void;
    onPassportQuantityChange: (value: number) => void;
    removeFromCart: () => void;
    removeVerifyHandler: (id: number) => void;
    removePassportHandler: (id: number) => void;
    addingItemToCart: (params: { quantity: number; verificationQuantity: number; passportQuantity: number }) => void;
    isSelected?: boolean;
    onSelectChange?: (checked: boolean) => void;
  }) => JSX.Element;
  isSelected?: boolean;
  onSelectChange?: (checked: boolean) => void;
}

export const CartItemLogic = ({
  item,
  CartItemUI,
  isSelected = false,
  onSelectChange,
}: CartItemLogicProps): JSX.Element => {
  const {
    quantity,
    verificationQuantity,
    passportQuantity,
    handleQuantityChange,
    handleVerificationChange,
    handlePassportChange,
    removeFromCart,
    removeVerification,
    removePassport,
    dispatchUpdate,
  } = useCartItemQuantity(item);

  const addingItemToCart = ({ quantity, verificationQuantity, passportQuantity }: { quantity: number; verificationQuantity: number; passportQuantity: number }) => {
    dispatchUpdate(quantity, verificationQuantity, passportQuantity);
  };

  return (
    <CartItemUI
      item={item}
      quantity={quantity}
      verificationQuantity={verificationQuantity}
      passportQuantity={passportQuantity}
      onQuantityChange={handleQuantityChange}
      onVerificationQuantityChange={handleVerificationChange}
      onPassportQuantityChange={handlePassportChange}
      removeFromCart={removeFromCart}
      removeVerifyHandler={removeVerification}
      removePassportHandler={removePassport}
      addingItemToCart={addingItemToCart}
      isSelected={isSelected}
      onSelectChange={onSelectChange}
    />
  );
};
